import React, { useState, useRef, useEffect } from "react";

// import css
import "./Mid-Section-Pc.scss";

//import icons
import { CiEdit } from "react-icons/ci";
import { FaArrowRightLong } from "react-icons/fa6";
import { SlLogout } from "react-icons/sl";
import { RiLockPasswordFill } from "react-icons/ri";
import { CgArrowsExchangeAlt } from "react-icons/cg";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import {
  getProfile,
  resetPassword,
  editProfile,
  editProfileImage, // <-- import the thunk
} from "../../../../redux/slices/sliceActions";

//tour utilities
import {
  advanceTour,
  isInTourMode,
  getCurrentTourStep,
} from "../../../../utils/tourUtils";

//custom toast
import customToasts from "../../../assets/reusableComponents/myToasts";
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";

const MidSectionProfilePc = () => {
  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile, message } = useSelector(
    (state) => state.landlordslice
  );
  const token = user?.accessToken;
  const id = user?.user?.user_id;

  const [profileUpdated, setProfileUpdated] = useState(false);

  useEffect(() => {
    console.log("user", user);
    dispatch(getProfile({ userId: user?.data?.id })).then((res) => {
      console.log("response", res);
      setProfileUpdated(true);
    });
  }, [user]);

  //input values
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [profilePicture, setProfilePicture] = useState(null);

  // Phone number validation state
  const [phoneError, setPhoneError] = useState("");

  // Track selected new profile picture and its preview
  const [selectedProfilePic, setSelectedProfilePic] = useState(null);
  const [selectedProfilePicPreview, setSelectedProfilePicPreview] =
    useState(null);

  useEffect(() => {
    if (profileUpdated && profile.name) {
      const { firstName, lastName } = getFirstAndLastName(profile.name);
      setFirstName(firstName);
      setLastName(lastName);
      setEmail(profile.email || "");
      setPhoneNumber(profile.phone || "");
      setProfilePicture(profile.image || null); // <-- use profile.image
      setSelectedProfilePic(null);
      setSelectedProfilePicPreview(null);
    }
  }, [profileUpdated]);

  const [activeItem, setActiveItem] = useState("Profile"); // State to keep track of the active item
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showDeletePicModal, setShowDeletePicModal] = useState(false);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  //function to handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "firstName":
        setFirstName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "phoneNumber":
        setPhoneError("");
        setPhoneNumber(value);
        break;
      case "oldPassword":
        setOldPassword(value);
        break;
      case "newPassword":
        setNewPassword(value);
        break;
      case "confirmPassword":
        setConfirmPassword(value);
      default:
        break;
    }
  };

  const handleNavItemClick = (item) => {
    setActiveItem(item);
  };
  //profile picture
  const fileInputRef = useRef(null);
  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedProfilePic(file);
      setSelectedProfilePicPreview(URL.createObjectURL(file));
    }
  };

  //focus
  const [focus, setFocus] = useState({}); // Track focus state

  const handleFocus = (inputName) => {
    setFocus({ ...focus, [inputName]: true });
  };

  const handleBlur = (inputName) => {
    setFocus({ ...focus, [inputName]: false });
  };

  //function to handle profile update
  const handleProfileUpdate = () => {
    // Validate phone number before submitting
    if (phoneError) {
      customToasts.error("Please enter a valid Kenyan phone number.");
      return;
    }
    console.log("Profile Updated");
    const fullName = `${firstName} ${lastName}`.trim();

    // Dispatch profile info update
    customToasts.promise(
      dispatch(
        editProfile({
          name: fullName,
          email: email,
          phone: `+254${phoneNumber.substring(1)}`, // Convert to international format
        })
      ).unwrap(),
      {
        pending: "Updating profile...",
        success: "Profile updated successfully",
        error: "Failed to update profile, please try again or contact support",
      }
    );

    // If a new profile picture is selected, dispatch its upload using editProfileImage
    if (selectedProfilePic) {
      customToasts.promise(
        dispatch(editProfileImage({ image: selectedProfilePic })).unwrap(),
        {
          pending: "Uploading profile picture...",
          success: "Profile picture updated successfully",
          error:
            "Failed to update profile picture, please try again or contact support",
        }
      );
    }

    setShowConfirmModal(false);
  };

  const handleConfirmChanges = () => {
    // Validate Kenyan phone number format: starts with 07 or 01 and 10 digits
    if (/^(07\d{8}|01\d{8})$/.test(phoneNumber)) {
      setPhoneError("");
    } else {
      setPhoneError(
        "Phone number must be in the format 07XXXXXXXX or 01XXXXXXXX"
      );
      customToasts.error("Please enter a valid Kenyan phone number.");
      return;
    }

    setShowConfirmModal(true);
  };

  const handleCancelModal = () => {
    setShowConfirmModal(false);
  };

  const handleDeletePicture = () => {
    setShowDeletePicModal(true);
  };

  const handleConfirmDeletePicture = () => {
    if (profilePicture || selectedProfilePicPreview) {
      dispatch(editProfileImage({ remove: true }));
    }
    setSelectedProfilePic(null);
    setSelectedProfilePicPreview(null);
    setProfilePicture(null);
    setShowDeletePicModal(false);
  };

  const handleCancelDeletePicture = () => {
    setShowDeletePicModal(false);
  };

  const updatePasswordFunction = () => {
    //confirm all fields are filled
    if (!oldPassword || !newPassword || !confirmPassword) {
      customToasts.error("Please fill in all fields");
      return;
    }
    //confirm if the new password and confirm password are the same
    if (newPassword !== confirmPassword) {
      customToasts.error("New password and confirm password do not match");
      return;
    }
    //confirm if the old password is the same as the new password
    if (oldPassword === newPassword) {
      customToasts.error("Old password and new password cannot be the same");
      return;
    }

    // Use the promise with toast
    customToasts
      .promise(
        dispatch(resetPassword({ oldPassword, newPassword })).unwrap(),
        {
          pending: "Updating password...",
          success: "Password updated successfully",
          error: {
            render({ data }) {
              // Use the error message from the response if it exists
              return data?.response?.data?.message || "An error occurred";
            },
          },
        },
        {
          isPasswordReset: true, // This is the correct way to pass the option
        }
      )
      .then(() => {
        // Advance tour if in tour mode and on Profile step
        if (isInTourMode() && getCurrentTourStep() === 0) {
          advanceTour();
        }
      })
      .catch((error) => {
        console.error("Password reset failed:", error);
      });
  };

  return (
    <div className="profile-pc">
      <div className="left-side-profile">
        <div
          className={`choice ${activeItem === "Profile" ? "active" : ""}`}
          onClick={() => handleNavItemClick("Profile")}
        >
          <div className="icon-and-title">
            <div className="icon">
              <CiEdit fontSize={25} />
            </div>
            <div className="title">Edit Profile</div>
          </div>
          <div className="active-shape"></div>
        </div>
        <div
          className={`choice ${activeItem === "Password" ? "active" : ""}`}
          onClick={() => handleNavItemClick("Password")}
        >
          <div className="icon-and-title">
            <div className="icon">
              <RiLockPasswordFill fontSize={25} />
            </div>
            <div className="title">Change Password</div>
          </div>
          <div className="active-shape"></div>
        </div>
      </div>
      <div className="right-side-profile">
        {activeItem === "Profile" && (
          <>
            <div className="edit-profile-page">
              <div className="top-half">
                <div className="title">Edit Profile</div>
                <div className="profile-pic-container">
                  {selectedProfilePicPreview || profilePicture ? (
                    <>
                      <img
                        src={selectedProfilePicPreview || profilePicture}
                        alt="profile picture"
                        className="profile-picture"
                      />
                    </>
                  ) : (
                    <div className="profile-pic"></div>
                  )}

                  <div className="buttons-containers">
                    <div className="upload-button">
                      Change Picture
                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: "block" }}
                        onChange={handleChange}
                      />
                    </div>
                    <div
                      className="upload-button"
                      onClick={handleDeletePicture}
                    >
                      Delete Picture
                    </div>
                  </div>
                </div>
              </div>
              <div className="bottom-half">
                <div className="fields-halves">
                  <div className="individual-half">
                    <label
                      htmlFor="first-name-input"
                      className={`text ${
                        focus["first-name-input"] ? "focus" : ""
                      }`}
                    >
                      First Name:
                    </label>
                    <input
                      type="text"
                      id="first-name-input"
                      placeholder="First Name eg John"
                      value={firstName}
                      name="firstName"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("first-name-input")}
                      onBlur={() => handleBlur("first-name-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="individual-half">
                    <label
                      htmlFor="last-name-input"
                      className={`text ${
                        focus["last-name-input"] ? "focus" : ""
                      }`}
                    >
                      Last Name:
                    </label>
                    <input
                      type="text"
                      id="last-name-input"
                      value={lastName}
                      placeholder="Last Name eg Doe"
                      name="lastName"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("last-name-input")}
                      onBlur={() => handleBlur("last-name-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="email-input"
                      className={`text ${focus["email-input"] ? "focus" : ""}`}
                    >
                      email
                    </label>
                    <input
                      type="text"
                      id="email-input"
                      value={email}
                      name="email"
                      placeholder="Email Address eg example@example.com"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("email-input")}
                      onBlur={() => handleBlur("email-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="phone-number-input"
                      className={`text ${
                        focus["phone-number-input"] ? "focus" : ""
                      }`}
                    >
                      Phone Number
                    </label>
                    <input
                      type="text"
                      id="phone-number-input"
                      value={phoneNumber}
                      placeholder="Phone Number eg 07XXXXXXXX or 01XXXXXXXX"
                      name="phoneNumber"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("phone-number-input")}
                      onBlur={() => handleBlur("phone-number-input")}
                      onChange={handleInputChange}
                    />
                    {phoneError && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "0.9rem",
                          marginTop: "0.3rem",
                        }}
                      >
                        {phoneError}
                      </div>
                    )}
                  </div>
                </div>

                <div className={"buttons-container "}>
                  <div className="upload-button" onClick={handleConfirmChanges}>
                    Confirm Changes
                  </div>
                  <div className="upload-button">Cancel Changes</div>
                </div>
              </div>
            </div>
          </>
        )}
        {activeItem === "Password" && (
          <>
            <div className="change-password-page">
              <div className="top-half">
                <div className="title">Change Password</div>
                <div className="sub-title">
                  Change your password by entering the old password first, then
                  the new one
                </div>
              </div>
              <div className="bottom-half">
                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="old-password-input"
                      className={`text ${
                        focus["old-password-input"] ? "focus" : ""
                      }`}
                    >
                      Old Password
                    </label>
                    <input
                      type="password"
                      id="old-password-input"
                      placeholder="Enter old password"
                      name="oldPassword"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("old-password-input")}
                      onBlur={() => handleBlur("old-password-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="new-password-input"
                      className={`text ${
                        focus["new-password-input"] ? "focus" : ""
                      }`}
                    >
                      New Password
                    </label>
                    <input
                      type="password"
                      id="new-password-input"
                      placeholder="Enter new password"
                      name="newPassword"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("new-password-input")}
                      onBlur={() => handleBlur("new-password-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="confirm-password-input"
                      className={`text ${
                        focus["confirm-password-input"] ? "focus" : ""
                      }`}
                    >
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      id="confirm-password-input"
                      placeholder="Confirm new password"
                      name="confirmPassword"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("confirm-password-input")}
                      onBlur={() => handleBlur("confirm-password-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className={"buttons-container "}>
                  <div
                    className="upload-button"
                    onClick={updatePasswordFunction}
                  >
                    Confirm Changes
                  </div>
                  <div className="upload-button">Cancel Changes</div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="title">Confirm Profile Changes</div>
            <div className="sub-title">
              Are you sure you want to update your profile with the following
              information?
            </div>
            <div className="modal-details">
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                {selectedProfilePicPreview || profilePicture ? (
                  <img
                    src={selectedProfilePicPreview || profilePicture}
                    alt="profile preview"
                    className="profile-picture"
                    style={{ width: 60, height: 60, borderRadius: "50%" }}
                  />
                ) : (
                  <div
                    className="profile-pic"
                    style={{
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                      background: "#192a3a",
                    }}
                  ></div>
                )}
                <span>Profile Picture</span>
              </div>
              <div className="sub-title">
                <strong>Name:</strong> {firstName} {lastName}
              </div>
              <div className="sub-title">
                <strong>Email:</strong> {email}
              </div>
              <div className="sub-title">
                <strong>Phone:</strong> {phoneNumber}
              </div>
            </div>
            <div className="modal-buttons">
              <button className="confirm-btn" onClick={handleProfileUpdate}>
                Yes, Update Profile
              </button>
              <button className="cancel-btn" onClick={handleCancelModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Picture Confirmation Modal */}
      {showDeletePicModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="title">Delete Profile Picture</div>
            <div className="sub-title">
              Are you sure you want to remove your profile picture?
            </div>
            <div className="modal-buttons">
              <button
                className="confirm-btn"
                onClick={handleConfirmDeletePicture}
              >
                Yes, Delete Picture
              </button>
              <button
                className="cancel-btn"
                onClick={handleCancelDeletePicture}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
};

function getFirstAndLastName(userName) {
  // Split the user name by space to separate the first and last names
  const nameParts = userName.split(" ");

  // Check if the split array has at least two elements (first name and last name)
  if (nameParts.length >= 2) {
    const firstName = nameParts[0]; // First element is the first name
    const lastName = nameParts[1]; // Second element is the last name
    return { firstName, lastName };
  } else {
    // If the input doesn't have a last name, return null for last name
    return { firstName: nameParts[0], lastName: null };
  }
}

export default MidSectionProfilePc;
